// extracted by mini-css-extract-plugin
export var title = "landing-image-module--title--LcmyO";
export var subtitleTop = "landing-image-module--subtitle-top--2rRqp";
export var img = "landing-image-module--img--lYavp";